import Vue from 'vue'
import Router from 'vue-router'

const originalPush = Router.prototype.push
const originalReplace = Router.prototype.replace
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch((err) => err)
}

Router.prototype.replace = function replace(location) {
    return originalReplace.call(this, location).catch((err) => err)
}

import index from '@/pages/index' 

Vue.use(Router)

export default new Router({
    scrollBehavior: () => ({ y: 0 }),
    routes: [
        {
            path: '/',
            component: index
        }
    ]
})
